<template>
  <div class="image-upload">
    <el-upload
      :action="action"
      :headers="{ Authorization }"
      name="file"
      :accept="accept"
      list-type="picture-card"
      :limit="numLimit"
      :file-list="fileList"
      :before-upload="upLoadBefore"
      :on-success="uploadSuccess"
      :on-remove="uploadRemove"
      :on-error="uploadError"
      :on-exceed="exceed"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
  </div>
</template>

<script>
import { storage } from "@/utils/public";
export default {
  name: "imageUpload",
  props: ["url", "accept", "sizeLimit", "numLimit", "fileList"],
  data() {
    const DOMAIN =
      process.env.NODE_ENV === "development"
        ? process.env.VUE_APP_DEV_DOMAIN
        : process.env.VUE_APP_DOMAIN;
    return {
      action: DOMAIN + this.url,
      Authorization: "Bearer " + storage.getSession("token")
    };
  },
  methods: {
    //上传之前验证
    upLoadBefore(file) {
      const verificationType = this.accept.includes(file.type),
        verificationSize = file.size / 1024 / 1024 < this.sizeLimit;
      if (!verificationType) {
        this.$message.error("上传的文件类型有误");
      }
      if (!verificationSize) {
        this.$message.error(`上传头像图片大小不能超过${this.sizeLimit}MB!`);
      }
      return verificationType && verificationSize;
    },
    uploadSuccess(res, file, fileList) {
      //判断是否真正成功
      if (res.Code === 0) {
        file.url = process.env.VUE_APP_DEV_IMGUPLOADDOMAIN + res.UrlList[0];
        this.updateFileList(fileList);
      } else {
        //服务器没响应成功 从fileList中删除当前的file
        fileList.some((item, index) => {
          if (Object.is(item, file)) {
            fileList.splice(index, 1);
            return true;
          }
        });
        this.$message.error(res.Message);
        if (res.Code === 1003) {
          this.redirectByPath("/");
        }
      }
    },
    uploadRemove(file, fileList) {
      this.updateFileList(fileList);
    },
    updateFileList(fileList) {
      // console.log(fileList);
      this.$emit("update:fileList", fileList);
    },
    //调取接口失败
    uploadError(error) {
      // 状态码判断
      switch (error.status) {
        case 401:
          this.$message.error("登录信息失效，请重新登录");
          break;
        case 404:
          this.$message.error("请求的资源不存在");
          break;
        default:
          this.$message.error(error.message);
      }
    },
    //触发numLimit
    exceed() {
      this.$message.error(`最多只能上传${this.numLimit}张图片`);
    }
  }
};
</script>

<style lang="less">
.image-upload {
  .el-upload {
    position: relative;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;
    &:hover {
      border-color: #409eff;
    }
  }
  .el-icon-plus {
    font-size: 30px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }
}
</style>
